module.exports = __webpack_public_path__ + "img/202603_05.fd9e00f8.png";